import React, { Component, Fragment } from 'react'

export class BurgerBtn extends Component {

	constructor(props){
		super(props);
		this.state = {
			menustatus: false
		}
	}

	clickToggle = (e) => {
		if (this.state.menustatus ===  false) {
			this.setState({
				menustatus: true
			})
		} else {
			this.setState({
				menustatus: false
			})
		}
	}

	render() {
		return (
			<Fragment>
				<button onClick={this.clickToggle} className={`hamburger hamburger--slider hamburger--accessible js-hamburger ${this.state.menustatus ? 'is-active' : null} `} type="button">
					<span className="hamburger-box">
						<span className="hamburger-inner"></span>
					</span>
					<span className="hamburger-label">Menu</span>
				</button>
			</Fragment>
		)
	}
}

export default BurgerBtn
